
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import { ServiceCreateRequestType } from "./serviceCreate.types";
import { ISalons } from "@/entity/salons/salons.types";
import { IServicesCategory } from "@/entity/servicesCategory/services.category.types";
import { IAppointmentStatuses } from "@/entity/appointmentStatuses/appointment.statuses.types";
import {IWorkers} from "@/entity/workers/workers.types";
import { IOnlientPayment } from "@/entity/onlinePayment/onlinePayment.types";


@Component
export default class ServiceCreateForm extends Form{
    @Validate(required, i18nText("Введите название услуги"))
    name = '';
    online_appointment_name = null;
    description = null;

    @Validate(required, i18nText("Является ли запись активной"))
    active: boolean = true;

    price_first : number = 0;
    price_second : number = 0;

    @Validate(required, i18nText("Введите длительность услуги"))
    service_duration = '';

    image = null;

    category_id : number | null = null;
    category   : IServicesCategory | null = null;

    @Validate(required, i18nText("Выберите студию"))
    salon_id    : number | null = null;

    @Validate(required, i18nText("Выберите номенклатуру"))
    nomenclature_id    : number | null = null;

    @Validate(required, i18nText("Является ли запись онлайн"))
    online_appointment : boolean = false;

    payments : IOnlientPayment | null = null;

    appointment_statuses : IAppointmentStatuses | null = null;

    cosmetologists      : IWorkers | null = null;

    getFormData() : ServiceCreateRequestType {
        return {
            active:                     this.active,
            name:                       this.name,
            description:                this.description,
            online_appointment_name:    this.online_appointment_name,
            price_first:                this.price_first,
            price_second:               this.price_second,
            service_duration:           this.service_duration,
            category_id:                this.category_id,
            salon_id:                   this.salon_id,
            nomenclature_id:            this.nomenclature_id,
            image:                      this.image,
            online_appointment:         this.online_appointment,
        } 
    }

    setFormData(salons: ISalons, serviceCategory: IServicesCategory, appointment_statuses : IAppointmentStatuses, cosmetologists : IWorkers, payments : IOnlientPayment): void {
        this.category = serviceCategory;
        this.appointment_statuses = appointment_statuses;
        this.cosmetologists = cosmetologists;
        this.payments = payments;
    }


}
